import { render, staticRenderFns } from "./TaskPhotosDisplay.vue?vue&type=template&id=edd0d7a6&scoped=true&"
import script from "./TaskPhotosDisplay.vue?vue&type=script&lang=js&"
export * from "./TaskPhotosDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TaskPhotosDisplay.vue?vue&type=style&index=0&id=edd0d7a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd0d7a6",
  null
  
)

export default component.exports